import { MenuItem } from '@mode/shared/ui';

export class ContentTypeMenuItem implements MenuItem {
  static readonly COLLECTIONS: MenuItem = new ContentTypeMenuItem({
    name: 'Collections',
    value: 'collections',
  });

  static readonly DATASETS: MenuItem = new ContentTypeMenuItem({
    name: 'Datasets',
    value: 'DatasetReport',
  });

  static readonly REPORTS: MenuItem = new ContentTypeMenuItem({
    name: 'Reports',
    value: 'Report',
  });

  readonly name: MenuItem['name'];
  readonly value: MenuItem['value'];

  constructor({ name, value }: MenuItem) {
    this.name = name;
    this.value = value;
  }

  toString() {
    return this.name;
  }
}
